import { css } from '@emotion/react';
import { tokens, applyFont, shadow } from '@domain-group/fe-brary';
import { media } from '../../../../styles/breakpoints-2026';

const { colors, spacing, typography, borderRadius, shadows } = tokens;

export const card = css`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${spacing.s};
  width: 100%;
  padding: ${spacing.s} ${spacing.m} ${spacing.m};
  background: ${colors.neutral.surface.default};
  border: 1px solid ${colors.neutral.trim.default};
  border-radius: ${borderRadius.outer};
  text-decoration: none;
  transition:
    box-shadow 150ms ease,
    border-color 150ms ease;

  ${media('>=tablet')} {
    box-shadow: ${shadow(shadows.elevation3)};
  }

  img {
    display: block;
    max-width: 100%;
    height: auto;
  }

  &:hover {
    box-shadow: ${shadow(shadows.elevation4)};
  }

  &:active {
    box-shadow: ${shadow(shadows.elevation1)};
  }

  &:focus-visible:not(:active) {
    outline: none;
    border-color: ${colors.interactive.trim.selected};
  }
`;

export const content = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
`;

export const title = css`
  ${applyFont(typography.subheading)}
  color: ${colors.neutral.heavy.default};
  margin: 0;
`;

export const description = css`
  ${applyFont(typography.caption)}
  color: ${colors.neutral.medium.default};
  margin: 0;
`;

export const cta = css`
  ${applyFont(typography.bodyBold)}
  display: flex;
  align-items: center;
  gap: ${spacing.xs};
  color: ${colors.interactive.medium.default};
  transition: color 150ms ease;

  svg {
    flex-shrink: 0;
    fill: currentColor;
  }

  a:hover & {
    color: ${colors.interactive.medium.hover};
  }

  a:active & {
    color: ${colors.interactive.medium.pressed};
  }

  a:focus-visible & {
    color: ${colors.interactive.medium.selected};
  }
`;
